var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("normalDialog", {
    attrs: {
      title: _vm.$t("label_essweb_List_dialog_uploadTitleLabel"),
      dialog: _vm.show,
      maxWidth: "600",
      width: "600",
    },
    on: {
      close: function ($event) {
        return _vm.$emit("close")
      },
    },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c("v-file-input", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: false,
                  expression: "false",
                },
              ],
              attrs: {
                id: "fileInput",
                "hide-input": "",
                multiple: "",
                accept: "doc,docx,pdf,ppt,jpg,jpeg,png,xlsx,xls",
              },
              on: { change: _vm.chooseUploadFile },
            }),
            _c(
              "v-form",
              { ref: "form", attrs: { "lazy-validation": "" } },
              [
                _c(
                  "v-row",
                  { attrs: { align: "center" } },
                  [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c(
                          "v-card",
                          {
                            staticClass: "rounded-lg",
                            style: {
                              border: "2px dashed var(--main-border-color)",
                            },
                            attrs: { elevation: "0" },
                            on: {
                              dragover: _vm.fileDragover,
                              drop: _vm.fileDrop,
                            },
                          },
                          [
                            _c(
                              "v-sheet",
                              { staticClass: "text-center align-center" },
                              [
                                _c("div", [
                                  _c(
                                    "i",
                                    {
                                      staticClass:
                                        "material-icons-round md-72 text--secondary lighten-2",
                                    },
                                    [_vm._v("backup")]
                                  ),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "py-3" },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_update_components_tipLabel"
                                          )
                                        )
                                      ),
                                    ]),
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "text-capitalize ml-2",
                                        attrs: {
                                          color: "primary lighten-2 ",
                                          small: "",
                                          rounded: "",
                                        },
                                        on: { click: _vm.toChoose },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "label_essweb_update_components_browseBtnLabel"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.fileList.length
                      ? _c(
                          "v-col",
                          {
                            attrs: {
                              xs: "12",
                              sm: "12",
                              md: "12",
                              lg: "12",
                              cols: "12",
                            },
                          },
                          [
                            _c(
                              "v-container",
                              {
                                staticClass: "scroll_content_y pa-0 ma-0",
                                style: { maxHeight: "214px" },
                              },
                              _vm._l(_vm.fileList, function (item, index) {
                                return _c(
                                  "v-sheet",
                                  {
                                    key: "file--" + index + "---" + item.id,
                                    staticClass:
                                      "rounded-lg my-2 mrc-border-solid",
                                    staticStyle: { position: "relative" },
                                  },
                                  [
                                    item.uploading
                                      ? _c("v-progress-linear", {
                                          staticClass: "rounded-lg",
                                          style: { top: 0, zIndex: 0 },
                                          attrs: {
                                            absolute: "",
                                            height: "100%",
                                            "background-opacity": "0",
                                            "buffer-value": 100,
                                            color: "primary lighten-3",
                                          },
                                          model: {
                                            value: item.progress,
                                            callback: function ($$v) {
                                              _vm.$set(item, "progress", $$v)
                                            },
                                            expression: "item.progress",
                                          },
                                        })
                                      : _vm._e(),
                                    _c(
                                      "v-sheet",
                                      {
                                        staticClass:
                                          "text-left align-center d-flex transparent px-2 py-2",
                                        style: {
                                          zIndex: 1,
                                          position: "relative",
                                        },
                                      },
                                      [
                                        _c("svg-icon", {
                                          attrs: {
                                            size: "32",
                                            fill: item.updated
                                              ? "#0f46c1"
                                              : "grey",
                                            iconClass:
                                              item.file_type == "jpg"
                                                ? "filetype-jpg"
                                                : item.file_type == "csv"
                                                ? "filetype-csv"
                                                : item.file_type == "doc"
                                                ? "filetype-doc"
                                                : item.file_type == "gif"
                                                ? "filetype-gif"
                                                : item.file_type == "png"
                                                ? "filetype-png"
                                                : item.file_type == "xls"
                                                ? "filetype-xls"
                                                : item.file_type == "docx"
                                                ? "filetype-doc"
                                                : item.file_type == "xlsx"
                                                ? "filetype-xls"
                                                : item.file_type == "pdf"
                                                ? "filetype-pdf"
                                                : item.file_type == "ppt"
                                                ? "filetype-ppt"
                                                : item.file_type == "jpeg"
                                                ? "filetype-jpg"
                                                : "filetype-file",
                                          },
                                        }),
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "\n                    text-subtitle-2\n                    px-1\n                    transparent\n                    text-left\n                    align-center\n                    d-flex\n                  ",
                                          },
                                          [
                                            _c(
                                              "v-sheet",
                                              {
                                                staticClass:
                                                  "text-subtitle-2 transparent text-truncate",
                                                class: item.updated_fail
                                                  ? "red--text"
                                                  : "text--primary",
                                                style: { maxWidth: "90%" },
                                                attrs: { title: item.filename },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(item.filename) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text--secondary text-caption px-1",
                                              },
                                              [
                                                _vm._v(
                                                  "(" +
                                                    _vm._s(
                                                      _vm.$byteconvert(
                                                        item.size
                                                      )
                                                    ) +
                                                    ")"
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c("v-spacer"),
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: { small: "", icon: "" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.deleteItem(
                                                  item.id,
                                                  item
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "material-icons-round",
                                              },
                                              [_vm._v("delete")]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c(
                          "v-sheet",
                          { staticClass: "mrc_text_require text--secondary" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "label_essweb_List_dialog_staffFolderLabel"
                                )
                              )
                            ),
                          ]
                        ),
                        _c("v-autocomplete", {
                          attrs: {
                            items: _vm.allStaff,
                            filled: "",
                            dense: "",
                            disabled: _vm.staff ? true : false,
                            "append-icon": "arrow_drop_down",
                            "single-line": "",
                            placeholder:
                              _vm.$t(
                                "label_essweb_leaveBalance_list_staffNameLabel"
                              ) +
                              "/" +
                              _vm.$t(
                                "label_essweb_leaveBalance_list_staffIdLabel"
                              ),
                            chips: "",
                            "open-on-clear": false,
                            filter: _vm.$staffFilter,
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            "item-text": "staff_code",
                            "item-value": "staff_id",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "no-data",
                              fn: function () {
                                return [_c("noContent")]
                              },
                              proxy: true,
                            },
                            {
                              key: "selection",
                              fn: function (data) {
                                return [
                                  data.index < 1
                                    ? _c(
                                        "v-chip",
                                        _vm._b(
                                          {
                                            staticClass: "mx-0 mr-1 pr-2",
                                            attrs: {
                                              close: _vm.staff ? false : true,
                                              pill: "",
                                            },
                                            on: {
                                              "click:close": function ($event) {
                                                _vm.selectStaff = ""
                                              },
                                            },
                                          },
                                          "v-chip",
                                          data.attrs,
                                          false
                                        ),
                                        [
                                          _c("StaffAvatar", {
                                            attrs: {
                                              left: "",
                                              src: data.item.staff_avatar,
                                              staff_name:
                                                data.item.preferred_name,
                                            },
                                          }),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-inline-block text-truncate",
                                              staticStyle: {
                                                "max-width": "60px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$getCommonLangValue(
                                                      data.item.preferred_name
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                            {
                              key: "item",
                              fn: function (data) {
                                return [
                                  _c(
                                    "v-list",
                                    {
                                      attrs: {
                                        rounded: "",
                                        width: "100%",
                                        nav: "",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-list-item",
                                        {
                                          attrs: {
                                            rouned: "",
                                            width: "100%",
                                            nav: "",
                                            "two-line": "",
                                            dense: "",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-list-item-avatar",
                                            {
                                              staticClass:
                                                "ma-0 mr-1 white--text",
                                              attrs: { size: "36" },
                                            },
                                            [
                                              _c("StaffAvatar", {
                                                attrs: {
                                                  size: "36",
                                                  src: data.item.staff_avatar,
                                                  staff_name:
                                                    data.item.preferred_name,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-list-item-content",
                                            [
                                              _c(
                                                "v-list-item-title",
                                                { staticClass: "text-body-2" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$getCommonLangValue(
                                                        data.item.preferred_name
                                                      )
                                                    ) + " "
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text--secondary text-caption-xs",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          data.item.staff_code
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c("v-list-item-subtitle", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$getCommonLangValue(
                                                      data.item.job_post_name
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                          model: {
                            value: _vm.selectStaff,
                            callback: function ($$v) {
                              _vm.selectStaff = $$v
                            },
                            expression: "selectStaff",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("DateTimePicker", {
                          attrs: {
                            type: "date",
                            label: _vm.$t("label_essweb_List_dialog_DateLabel"),
                            defaultTime: _vm.date,
                            placeholder: "YYYY/MM/DD",
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                          },
                          on: {
                            change: function (time) {
                              _vm.date = time
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _c("CardActions", {
              attrs: { submitBtn: "" },
              on: {
                submit: _vm.toSubmit,
                cancel: function ($event) {
                  return _vm.$emit("close")
                },
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }